import { useCallback, useMemo } from "react";
import Label from "./Label";
import ErrorMessage from "./ErrorMessage";
import Hint from "./Hint";
import Input from "./Input";
import classNames from "classnames";

import { WindowWidth } from "./WindowWidth";
import {
  GOVGR_EXCLAMATION_WIDTH_FULL,
  GOVGR_FIELD,
  GOVGR_FIELD__ERROR,
  GOVGR_INPUT,
  GOVGR_ERROR_INPUT,
} from "../../conf/styles/GovGrTextfield";
import { FIELD_CANT_BE_EDITED_TEXT, MOBILE_DEVICES_WIDTH } from "./constants";

const TextFieldComponent = ({
  field,
  form: { setFieldValue, setFieldTouched, touched, errors },
  ...props
}) => {
  const mobileDevicesHiddenNoHint = WindowWidth(MOBILE_DEVICES_WIDTH);

  const onChange = useCallback(
    (e) => {
      const { value } = e.target;

      setFieldValue(field.name, value);
    },
    [setFieldValue, field.name]
  );

  const checkErrorsAndTouchFields = useMemo(
    () => touched[field.name] && !!errors[field.name],
    [touched[field.name], errors[field.name]]
  );

  let disabledmessage = props.disabledmessage
    ? props.disabledmessage
    : FIELD_CANT_BE_EDITED_TEXT;

  let hintMessage = props.hint ? props.hint : `\u00A0`;

  const hintMessageWhichIsHiddenOnMobile = useMemo(
    () => (mobileDevicesHiddenNoHint ? hintMessage : ""),
    [mobileDevicesHiddenNoHint]
  );

  // Add classes conditionally if field is touched or has error
  let wrapperClassName = classNames(GOVGR_FIELD, {
    [`${GOVGR_FIELD__ERROR}`]: checkErrorsAndTouchFields,
  });

  // Input class based on disabled message or field has error or it's touched
  let inputClassName = classNames(
    GOVGR_INPUT,
    GOVGR_EXCLAMATION_WIDTH_FULL,
    "leading-[1.62rem]",
    {
      [`${GOVGR_ERROR_INPUT}`]: checkErrorsAndTouchFields,
      "disabled:opacity-100": !!props.disabled,
    }
  );

  return (
    <div className={wrapperClassName} {...props}>
      <Label
        labelText={props.label}
        disabled={props.disabled}
        inputname={field.name}
      />

      {checkErrorsAndTouchFields ? (
        <ErrorMessage errorFieldName={errors[`${field.name}`]} />
      ) : (
        <Hint
          nohint={props.nohint}
          hint={
            !!props.disabled
              ? disabledmessage
              : hintMessageWhichIsHiddenOnMobile
          }
        />
      )}
      <Input
        className={inputClassName}
        type="text"
        name={field.name}
        onChange={onChange}
        value={field.value || ""}
        onBlur={() => setFieldTouched(field.name, true)}
        disabled={!!props.disabled}
        readOnly={!!props.disabled}
        id={field.name}
      />
    </div>
  );
};

export default TextFieldComponent;
